import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { ChainWideMistsComponent } from '@app/features/mists/modules/chain-wide-mists/chain-wide-mists.component';
import { Authority } from '@app/shared/utils/enums';

export const chainWideMistsRoutes: Routes = [
    {
        path: 'chain-wide-mists',
        children: [
            {
                path: '',
                component: ChainWideMistsComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.UPDATE]
                },
                canActivate: [RouteAccessGuard]
            }
        ]
    }
]